import { confirm } from "../utils/confirm";

/**
 * Confirms a destructive action.
 *
 * Returns a promise now that the confirmation is an in-app dialog
 * rather than window.confirm, so callers must await it:
 *
 *   if (!(await isSure())) return;
 *
 * @param text overrides the default warning
 */
export const isSure = (text?: string): Promise<boolean> =>
  confirm({
    message:
      text ?? "Sind Sie sicher? Dies kann nicht rückgängig gemacht werden.",
    destructive: true,
    confirmLabel: "Ja, fortfahren",
  });
